import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "g-container pl-[16px] sm:pl-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl sm:text-4xl leading-[50px] font-normal text-gary-line-color pt-[20px]" }, " 我的禮物清單 ", -1)
const _hoisted_3 = { class: "shopping-cart-breadcrumb leading-[18px] items-center flex gap-3 text-xs sm:text-[13px] font-bold flex mb-[21px] mt-1.5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex items-center mb-[6px] leading-[26px] text-gary-text-color tracking-[.06em]"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 全部禮物 ")
const _hoisted_8 = { class: "g-container" }
const _hoisted_9 = { class: "flex flex-col sm:flex-row gap-5 sm:gap-2.5 mt-2.5" }
const _hoisted_10 = { class: "grow" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-2.5"
}
const _hoisted_12 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_13 = { class: "flex my-5" }
const _hoisted_14 = { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "grow flex flex-col" }
const _hoisted_17 = { class: "flex ml-[30px]" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_20 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_21 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_22 = { class: "hidden" }
const _hoisted_23 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_25 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_30 = { class: "grow h-[60px] flex items-center" }
const _hoisted_31 = { class: "grow mr-[10px]" }
const _hoisted_32 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_33 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_34 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_35 = {
  key: 0,
  class: "hidden flex"
}
const _hoisted_36 = { class: "grow ml-[180px] flex flex-col" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "w-[46%]" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "w-[20px] mr-1.5" }
const _hoisted_41 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_42 = { class: "flex mb-[20px]" }
const _hoisted_43 = { class: "w-[80px] mr-[20px]" }
const _hoisted_44 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_46 = { class: "grow flex" }
const _hoisted_47 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-[22%] ml-[30px]" }, null, -1)
const _hoisted_49 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_50 = { class: "flex pt-[20px] bg-img-background" }
const _hoisted_51 = {
  key: 0,
  class: "w-[70px]"
}
const _hoisted_52 = {
  key: 1,
  class: "w-[50px]"
}
const _hoisted_53 = { class: "w-[80px]" }
const _hoisted_54 = { class: "grow flex flex-col" }
const _hoisted_55 = { class: "flex ml-[30px]" }
const _hoisted_56 = { class: "w-[46%]" }
const _hoisted_57 = { class: "flex" }
const _hoisted_58 = { class: "w-[20px] mr-1.5" }
const _hoisted_59 = { class: "flex hidden" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_62 = { class: "grow h-[60px] flex items-center" }
const _hoisted_63 = { class: "grow mr-[10px]" }
const _hoisted_64 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_65 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_66 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_67 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_68 = {
  key: 0,
  class: "w-[70px]"
}
const _hoisted_69 = {
  key: 1,
  class: "w-[50px]"
}
const _hoisted_70 = { class: "w-[80px]" }
const _hoisted_71 = { class: "grow flex flex-col" }
const _hoisted_72 = { class: "flex ml-[30px]" }
const _hoisted_73 = { class: "w-[46%]" }
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = { class: "w-[20px] mr-1.5" }
const _hoisted_76 = { class: "flex hidden" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_79 = { class: "grow h-[60px] flex items-center" }
const _hoisted_80 = { class: "grow mr-[10px]" }
const _hoisted_81 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_82 = {
  key: 0,
  class: "flex w-[22%] mr-[30px] justify-end"
}
const _hoisted_83 = { class: "flex justify-end my-1.5" }
const _hoisted_84 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_86 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_87 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_88 = { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "grow flex flex-col" }
const _hoisted_91 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_92 = { class: "flex flex-col gap-1" }
const _hoisted_93 = { class: "flex flex-row justify-between" }
const _hoisted_94 = { class: "" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_98 = { class: "hidden" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_103 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_106 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_107 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_108 = { class: "mr-[16px]" }
const _hoisted_109 = {
  key: 0,
  class: "text-xs items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_110 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_111 = {
  key: 0,
  class: "hidden flex flex-row mb-3"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[46px]" }, null, -1)
const _hoisted_113 = { class: "w-[60px]" }
const _hoisted_114 = { class: "grow flex flex-col" }
const _hoisted_115 = { class: "flex flex-col ml-[6px]" }
const _hoisted_116 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_117 = { class: "flex flex-row justify-between" }
const _hoisted_118 = { class: "" }
const _hoisted_119 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_120 = { class: "flex" }
const _hoisted_121 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_123 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_124 = { class: "mr-[16px]" }
const _hoisted_125 = {
  key: 0,
  class: "text-xs sm:leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_126 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_127 = {
  key: 1,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_128 = { class: "bg-img-background flex pt-[20px] flex-row pt-5 pb-5" }
const _hoisted_129 = {
  key: 0,
  class: "ml-[46px]"
}
const _hoisted_130 = {
  key: 1,
  class: "ml-[26px]"
}
const _hoisted_131 = { class: "w-[60px]" }
const _hoisted_132 = { class: "grow flex flex-col" }
const _hoisted_133 = { class: "flex flex-col ml-[6px]" }
const _hoisted_134 = { class: "flex flex-col gap-1" }
const _hoisted_135 = { class: "flex flex-row justify-between" }
const _hoisted_136 = { class: "max-w-[180px]" }
const _hoisted_137 = { class: "flex" }
const _hoisted_138 = { class: "w-[20px] mr-1.5" }
const _hoisted_139 = { class: "items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_142 = {
  key: 0,
  class: "flex gap-1 mt-0.5 mr-[16px] justify-end"
}
const _hoisted_143 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_144 = { class: "mr-[16px]" }
const _hoisted_145 = { class: "text-xs items-center text-light-gary-text-color line-through text-right" }
const _hoisted_146 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_147 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_148 = {
  key: 0,
  class: "ml-[46px]"
}
const _hoisted_149 = {
  key: 1,
  class: "ml-[26px]"
}
const _hoisted_150 = { class: "w-[60px]" }
const _hoisted_151 = { class: "grow flex flex-col" }
const _hoisted_152 = { class: "flex flex-col ml-[6px]" }
const _hoisted_153 = { class: "flex flex-col gap-1" }
const _hoisted_154 = { class: "flex flex-row justify-between" }
const _hoisted_155 = { class: "max-w-[180px]" }
const _hoisted_156 = { class: "flex" }
const _hoisted_157 = { class: "w-[20px] mr-1.5" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_160 = {
  key: 0,
  class: "flex gap-1 mt-0.5 mr-[16px] justify-end"
}
const _hoisted_161 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_162 = { class: "mr-[16px]" }
const _hoisted_163 = { class: "text-xs items-center text-light-gary-text-color line-through text-right" }
const _hoisted_164 = { class: "flex justify-end mx-[16px] my-3" }
const _hoisted_165 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_167 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_168 = { class: "w-[20px] mr-2.5" }
const _hoisted_169 = /*#__PURE__*/_createTextVNode(" 滿額加購")
const _hoisted_170 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_171 = { class: "flex mt-5" }
const _hoisted_172 = { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }
const _hoisted_173 = ["onClick"]
const _hoisted_174 = { class: "grow flex flex-col" }
const _hoisted_175 = { class: "flex ml-[30px]" }
const _hoisted_176 = ["onClick"]
const _hoisted_177 = { class: "flex text-base font-medium text-gary-text-color" }
const _hoisted_178 = { class: "mr-1.5 w-[20px]" }
const _hoisted_179 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_180 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_181 = { class: "hidden" }
const _hoisted_182 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_183 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_184 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_185 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_186 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_189 = { class: "grow h-[60px] flex items-center" }
const _hoisted_190 = { class: "grow mr-[10px]" }
const _hoisted_191 = {
  key: 0,
  class: "text-xs leading-10 items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_192 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left" }
const _hoisted_193 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end cursor-pointer" }
const _hoisted_194 = { class: "flex justify-end my-1.5" }
const _hoisted_195 = { class: "hidden ml-[24px] my-1.5 flex leading-[17px] items-center gap-1.5 text-xs text-primary-color cursor-pointer" }
const _hoisted_196 = /*#__PURE__*/_createTextVNode("點選看更多優惠 ")
const _hoisted_197 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_199 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_200 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_201 = { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { class: "grow flex flex-col" }
const _hoisted_204 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_205 = { class: "flex flex-col gap-1" }
const _hoisted_206 = { class: "flex flex-row justify-between" }
const _hoisted_207 = { class: "" }
const _hoisted_208 = ["onClick"]
const _hoisted_209 = { class: "mr-1.5 w-[20px]" }
const _hoisted_210 = ["onClick"]
const _hoisted_211 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_212 = { class: "hidden" }
const _hoisted_213 = { key: 0 }
const _hoisted_214 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_215 = { key: 1 }
const _hoisted_216 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_217 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_220 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_221 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_222 = { class: "mr-[16px]" }
const _hoisted_223 = {
  key: 0,
  class: "text-xs items-center text-light-gary-text-color line-through text-right"
}
const _hoisted_224 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_225 = { class: "flex justify-end mx-[16px] my-3" }
const _hoisted_226 = { class: "hidden flex leading-[17px] items-center gap-1.5 text-xs text-primary-color cursor-pointer" }
const _hoisted_227 = /*#__PURE__*/_createTextVNode("點選看更多優惠 ")
const _hoisted_228 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_230 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_231 = { class: "w-[20px] mr-2.5" }
const _hoisted_232 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_233 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_234 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] items-center" }, null, -1)
const _hoisted_236 = { class: "w-[80px]" }
const _hoisted_237 = { class: "grow flex flex-col" }
const _hoisted_238 = { class: "flex ml-[30px]" }
const _hoisted_239 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_240 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_241 = { class: "mr-1.5 w-[20px]" }
const _hoisted_242 = { class: "text-[13px] ml-[26px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_243 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_244 = { class: "hidden" }
const _hoisted_245 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_246 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_247 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_248 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_249 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_250 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_251 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_252 = { class: "grow h-[60px] pl-[50px] flex items-center" }
const _hoisted_253 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_254 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_255 = { class: "flex flex-row h-[80px] mx-[23px] items-center" }
const _hoisted_256 = ["onClick"]
const _hoisted_257 = { class: "grow flex flex-col" }
const _hoisted_258 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_259 = { class: "flex flex-col gap-1" }
const _hoisted_260 = { class: "flex flex-row justify-between" }
const _hoisted_261 = { class: "" }
const _hoisted_262 = ["onClick"]
const _hoisted_263 = ["onClick"]
const _hoisted_264 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_265 = { class: "hidden" }
const _hoisted_266 = { key: 0 }
const _hoisted_267 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_268 = { key: 1 }
const _hoisted_269 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_270 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_272 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_273 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_274 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_275 = {
  key: 1,
  class: "flex flex-col gap-2.5"
}
const _hoisted_276 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_277 = { class: "flex mt-5" }
const _hoisted_278 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_279 = ["onClick"]
const _hoisted_280 = { class: "grow flex flex-col" }
const _hoisted_281 = { class: "flex ml-[30px]" }
const _hoisted_282 = ["onClick"]
const _hoisted_283 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_284 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_285 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_286 = { class: "hidden" }
const _hoisted_287 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_288 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_289 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_290 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_291 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_292 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_293 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_294 = { class: "grow h-[60px] flex items-center" }
const _hoisted_295 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_296 = { class: "grow mr-7 flex" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_298 = {
  key: 0,
  class: "text-[13px] ml-[10px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right"
}
const _hoisted_299 = {
  key: 0,
  class: "hidden flex"
}
const _hoisted_300 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[30px]" }, null, -1)
const _hoisted_301 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[130px]" }, null, -1)
const _hoisted_302 = { class: "grow flex flex-col" }
const _hoisted_303 = { class: "flex" }
const _hoisted_304 = { class: "w-[46%]" }
const _hoisted_305 = { class: "flex" }
const _hoisted_306 = { class: "w-[20px] mr-1.5" }
const _hoisted_307 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_308 = { class: "flex mb-[20px]" }
const _hoisted_309 = { class: "w-[80px] mr-[20px]" }
const _hoisted_310 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_311 = /*#__PURE__*/_createElementVNode("li", null, "包裝盒 x1", -1)
const _hoisted_312 = /*#__PURE__*/_createElementVNode("li", null, "吊卡 x1", -1)
const _hoisted_313 = /*#__PURE__*/_createElementVNode("li", null, "貼紙 x1", -1)
const _hoisted_314 = /*#__PURE__*/_createElementVNode("li", null, "防塵袋 x1", -1)
const _hoisted_315 = /*#__PURE__*/_createElementVNode("li", null, "紙袋 x1", -1)
const _hoisted_316 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_317 = { class: "grow flex" }
const _hoisted_318 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right mr-[30px]" }
const _hoisted_319 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_320 = { class: "bg-img-background flex py-[20px]" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_322 = { class: "w-[80px]" }
const _hoisted_323 = { class: "grow flex flex-col" }
const _hoisted_324 = { class: "flex ml-[30px]" }
const _hoisted_325 = { class: "w-[46%]" }
const _hoisted_326 = { class: "flex" }
const _hoisted_327 = { class: "w-[20px] mr-1.5" }
const _hoisted_328 = { class: "flex items-center mb-1.5 font-medium text-sm text-gary-text-color" }
const _hoisted_329 = { class: "flex" }
const _hoisted_330 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_331 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_332 = { class: "grow h-[60px] flex items-center" }
const _hoisted_333 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_334 = { class: "grow mr-[30px]" }
const _hoisted_335 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_336 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_337 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_338 = { class: "w-[80px]" }
const _hoisted_339 = { class: "grow flex flex-col" }
const _hoisted_340 = { class: "flex ml-[30px]" }
const _hoisted_341 = { class: "w-[46%]" }
const _hoisted_342 = { class: "flex" }
const _hoisted_343 = { class: "w-[20px] mr-1.5" }
const _hoisted_344 = { class: "flex" }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_346 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_347 = { class: "grow h-[60px] flex items-center" }
const _hoisted_348 = { class: "grow mr-[30px]" }
const _hoisted_349 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_350 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_351 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_352 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_353 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_354 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_355 = ["onClick"]
const _hoisted_356 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_357 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_358 = { class: "flex flex-col gap-1" }
const _hoisted_359 = { class: "flex flex-row justify-between" }
const _hoisted_360 = { class: "" }
const _hoisted_361 = ["onClick"]
const _hoisted_362 = ["onClick"]
const _hoisted_363 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_364 = { class: "hidden" }
const _hoisted_365 = { key: 0 }
const _hoisted_366 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_367 = { key: 1 }
const _hoisted_368 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_369 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_370 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_371 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_372 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_373 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_374 = { class: "mr-[16px]" }
const _hoisted_375 = { class: "grow mr-7" }
const _hoisted_376 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_377 = {
  key: 0,
  class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right"
}
const _hoisted_378 = {
  key: 0,
  class: "hidden flex flex-row mb-3"
}
const _hoisted_379 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_380 = { class: "w-[60px]" }
const _hoisted_381 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_382 = { class: "flex flex-col ml-[6px]" }
const _hoisted_383 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_384 = { class: "flex flex-row justify-between" }
const _hoisted_385 = { class: "" }
const _hoisted_386 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_387 = { class: "flex" }
const _hoisted_388 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_389 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_390 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_391 = { class: "mr-[16px]" }
const _hoisted_392 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_393 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_394 = { class: "bg-img-background flex flex-row pt-5 pb-5" }
const _hoisted_395 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_396 = { class: "w-[60px]" }
const _hoisted_397 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_398 = { class: "flex flex-col ml-[6px]" }
const _hoisted_399 = { class: "flex flex-col gap-1" }
const _hoisted_400 = { class: "flex flex-row justify-between" }
const _hoisted_401 = { class: "" }
const _hoisted_402 = { class: "flex items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_403 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_404 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_405 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_406 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_407 = { class: "mr-[16px]" }
const _hoisted_408 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_409 = {
  key: 3,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_410 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_411 = { class: "w-[60px]" }
const _hoisted_412 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_413 = { class: "flex flex-col ml-[6px]" }
const _hoisted_414 = { class: "flex flex-col gap-1" }
const _hoisted_415 = { class: "flex flex-row justify-between" }
const _hoisted_416 = { class: "" }
const _hoisted_417 = { class: "flex" }
const _hoisted_418 = { class: "w-[20px] mr-1.5" }
const _hoisted_419 = /*#__PURE__*/_createElementVNode("li", null, "15x16cm", -1)
const _hoisted_420 = /*#__PURE__*/_createElementVNode("li", null, "霧面", -1)
const _hoisted_421 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_422 = { class: "mr-[16px]" }
const _hoisted_423 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_424 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_425 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_426 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_427 = /*#__PURE__*/_createTextVNode("滿額加購 ")
const _hoisted_428 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_429 = { class: "flex mt-5" }
const _hoisted_430 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_431 = ["onClick"]
const _hoisted_432 = { class: "grow flex flex-col" }
const _hoisted_433 = { class: "flex ml-[30px]" }
const _hoisted_434 = ["onClick"]
const _hoisted_435 = { class: "flex text-base font-medium text-gary-text-color" }
const _hoisted_436 = { class: "mr-1.5 w-[20px]" }
const _hoisted_437 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_438 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_439 = { class: "hidden" }
const _hoisted_440 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_441 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_442 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_443 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_444 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_445 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_446 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_447 = { class: "grow h-[60px] flex items-center" }
const _hoisted_448 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_449 = { class: "grow mr-7" }
const _hoisted_450 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_451 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_452 = { class: "flex gap-[14px] tracking-[.06em] mr-7 items-center text-sm" }
const _hoisted_453 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_454 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_455 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_456 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_457 = ["onClick"]
const _hoisted_458 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_459 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_460 = { class: "flex flex-col gap-1" }
const _hoisted_461 = { class: "flex flex-row justify-between" }
const _hoisted_462 = { class: "" }
const _hoisted_463 = ["onClick"]
const _hoisted_464 = { class: "mr-1.5 w-[20px]" }
const _hoisted_465 = ["onClick"]
const _hoisted_466 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_467 = { class: "hidden" }
const _hoisted_468 = { key: 0 }
const _hoisted_469 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_470 = { key: 1 }
const _hoisted_471 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_472 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_473 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_474 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_475 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_476 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_477 = { class: "mr-[16px]" }
const _hoisted_478 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_479 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_480 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center" }
const _hoisted_481 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_482 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_483 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_484 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_485 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_486 = { class: "flex flex-row h-[80px] ml-[25px] mr-[25px] items-center" }
const _hoisted_487 = { class: "w-[80px]" }
const _hoisted_488 = { class: "grow flex flex-col" }
const _hoisted_489 = { class: "flex ml-[30px]" }
const _hoisted_490 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_491 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_492 = { class: "mr-1.5 w-[20px]" }
const _hoisted_493 = { class: "ml-[26px] text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_494 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_495 = { class: "hidden" }
const _hoisted_496 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_497 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊 ")
const _hoisted_498 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_499 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊 ")
const _hoisted_500 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_501 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_502 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_503 = { class: "grow h-[60px] pl-[60px] flex items-center" }
const _hoisted_504 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_505 = { class: "flex flex-row mt-5 mb-3 ml-[25px]" }
const _hoisted_506 = ["onClick"]
const _hoisted_507 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_508 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_509 = { class: "flex flex-col gap-1" }
const _hoisted_510 = { class: "flex flex-row justify-between" }
const _hoisted_511 = { class: "" }
const _hoisted_512 = { class: "flex text-[13px] font-medium text-gary-text-color" }
const _hoisted_513 = { class: "mr-1.5 w-[20px]" }
const _hoisted_514 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_515 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_516 = { class: "hidden" }
const _hoisted_517 = { key: 0 }
const _hoisted_518 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_519 = { key: 1 }
const _hoisted_520 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_521 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_522 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_523 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_524 = {
  key: 0,
  class: "flex gap-1 mr-[16px] justify-end"
}
const _hoisted_525 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_526 = {
  key: 0,
  class: "step1 basis-[29%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0"
}
const _hoisted_527 = { class: "bg-white rounded-md" }
const _hoisted_528 = { class: "m-[36px] flex flex-col divide-y-2" }
const _hoisted_529 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_530 = { class: "flex text-sm" }
const _hoisted_531 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "訂單金額", -1)
const _hoisted_532 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_533 = { class: "flex text-sm" }
const _hoisted_534 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "商品折扣", -1)
const _hoisted_535 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_536 = { class: "pt-[20px]" }
const _hoisted_537 = { class: "flex text-black-900-color leading-[23px] items-center pb-[20px]" }
const _hoisted_538 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_539 = { class: "grow text-lg text-right font-bold" }
const _hoisted_540 = { class: "bg-black-300-color rounded-full h-2 dark:bg-black-300-color" }
const _hoisted_541 = ["innerHTML"]
const _hoisted_542 = {
  key: 0,
  class: "flex flex-col bg-white rounded-md gap-[30px] p-[30px] pr-[20px]"
}
const _hoisted_543 = /*#__PURE__*/_createElementVNode("div", { class: "text-center sm:font-bold text-gary-text-color text-2xl" }, " 滿額加購 ", -1)
const _hoisted_544 = ["onClick"]
const _hoisted_545 = { class: "w-[80px] mr-2" }
const _hoisted_546 = { class: "flex justify-between w-full" }
const _hoisted_547 = { class: "min-h-10 mr-[14px]" }
const _hoisted_548 = { class: "font-normal text-[0.9375rem] text-gary-text-color mt-[0.125rem]" }
const _hoisted_549 = { class: "font-normal text-[0.875rem] text-gary-text-color" }
const _hoisted_550 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_551 = {
  key: 0,
  class: "orange-price ml-2 line-through text-light-gary-text-color"
}
const _hoisted_552 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_553 = { class: "flex items-center" }
const _hoisted_554 = { class: "flex flex-col bg-white rounded-md gap-[30px] p-[30px] pr-[20px]" }
const _hoisted_555 = /*#__PURE__*/_createElementVNode("div", { class: "text-center sm:font-bold text-gary-text-color text-2xl" }, " 您也喜歡 ", -1)
const _hoisted_556 = ["onClick"]
const _hoisted_557 = { class: "w-[80px] mr-2" }
const _hoisted_558 = { class: "flex justify-between w-full" }
const _hoisted_559 = { class: "min-h-10 mr-[14px]" }
const _hoisted_560 = { class: "font-normal text-[0.9375rem] text-gary-text-color mt-[0.125rem]" }
const _hoisted_561 = { class: "font-normal text-[0.8125rem] text-light-gary-text-color" }
const _hoisted_562 = { class: "font-normal text-[0.875rem] text-gary-text-color" }
const _hoisted_563 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_564 = {
  key: 0,
  class: "orange-price ml-2 line-through text-light-gary-text-color"
}
const _hoisted_565 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT. ", -1)
const _hoisted_566 = { class: "flex items-center" }
const _hoisted_567 = {
  key: 1,
  class: "basis-[38%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0"
}
const _hoisted_568 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px]" }
const _hoisted_569 = { class: "flex flex-col px-[20px] w-full" }
const _hoisted_570 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg text-gary-text-color pb-5" }, [
  /*#__PURE__*/_createTextVNode(" 訂購人資料"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-breadcrumb-color pl-3 tracking-[.1em] font-normal" }, "同會員資料")
], -1)
const _hoisted_571 = { class: "items-center text-sm text-left relative font-light pb-[20px] text-breadcrumb-color tracking-widest" }
const _hoisted_572 = /*#__PURE__*/_createTextVNode(" 手機 ")
const _hoisted_573 = { class: "pt-2 text-black-400-color" }
const _hoisted_574 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-breadcrumb-color pb-[20px]" }, " 訂單及發票資訊將用E-mail通知您，請確認資料的正確性 ", -1)
const _hoisted_575 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px]" }
const _hoisted_576 = { class: "px-[20px]" }
const _hoisted_577 = { class: "flex items-center justify-between" }
const _hoisted_578 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "運送方式", -1)
const _hoisted_579 = {
  key: 0,
  class: "text-xs text-dot-red"
}
const _hoisted_580 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_581 = { class: "flex gap-[22px] pb-2.5" }
const _hoisted_582 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_583 = { class: "text-gary-text-color tracking-[.06em]" }
const _hoisted_584 = {
  key: 0,
  class: "text-light-gary-text-color text-[13px] tracking-[.12em] grow"
}
const _hoisted_585 = {
  key: 1,
  class: "text-light-gary-text-color text-[13px] tracking-[.12em] grow"
}
const _hoisted_586 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_587 = { class: "flex gap-[10px]" }
const _hoisted_588 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_589 = { class: "text-gary-text-color font-bold text-sm" }
const _hoisted_590 = { class: "flex gap-[22px]" }
const _hoisted_591 = { class: "text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_592 = { class: "flex gap-[7px]" }
const _hoisted_593 = { class: "text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_594 = {
  key: 0,
  class: "text-gary-text-color tracking-[.06em] text-sm"
}
const _hoisted_595 = {
  key: 2,
  class: "text-sm text-light-gary-text-color tracking-[.06em]"
}
const _hoisted_596 = {
  key: 3,
  class: "text-sm text-light-gary-text-color tracking-[.06em]"
}
const _hoisted_597 = { class: "flex items-center mr-2" }
const _hoisted_598 = { class: "inline-block relative rounded-[4px] border-black-300-color border-solid border-[1px] hover:border-black active:border-black w-full" }
const _hoisted_599 = { class: "bg-white rounded-md py-[36px] px-2.5 sm:px-[20px] divide-y-2" }
const _hoisted_600 = { class: "mb-[30px] px-[20px]" }
const _hoisted_601 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 font-bold text-lg text-gary-text-color" }, " 選擇付款方式 ", -1)
const _hoisted_602 = { class: "flex flex-col gap-2.5" }
const _hoisted_603 = { class: "pt-[36px] px-[20px]" }
const _hoisted_604 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg text-gary-text-color" }, "發票類型", -1)
const _hoisted_605 = { key: 0 }
const _hoisted_606 = /*#__PURE__*/_createStaticVNode("<ul class=\"list-none list-inside text-breadcrumb-color text-xs\"><li><div class=\"inline-flex\"><span>・</span><span class=\"whitespace-pre-wrap break-all\"> 發票依財政部規定託管，不再開立紙本，電子發票將以E-mail寄發 </span></div></li><li><div class=\"inline-flex\"><span>・</span><span class=\"whitespace-pre-wrap break-all\"> 依統一發票使用辦法規定，個人發票一經開立，不得更改或改開公司戶發票，可至 <a href=\"https://www.einvoice.nat.gov.tw/\">財政部電子發票流程說明</a> 查看詳情 </span></div></li><li></li></ul>", 1)
const _hoisted_607 = [
  _hoisted_606
]
const _hoisted_608 = { key: 1 }
const _hoisted_609 = { class: "mt-[20px] flex font-bold text-lg text-gary-text-color pb-5" }
const _hoisted_610 = /*#__PURE__*/_createTextVNode(" 手機條碼載具 ")
const _hoisted_611 = /*#__PURE__*/_createTextVNode("我同意紀錄手機條碼為常用載具 ")
const _hoisted_612 = { key: 2 }
const _hoisted_613 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[20px] mb-2.5 font-bold text-lg text-gary-text-color" }, " 統一編號 ", -1)
const _hoisted_614 = { class: "mt-[20px] flex font-bold text-lg text-gary-text-color pb-5" }
const _hoisted_615 = /*#__PURE__*/_createTextVNode(" E-mail ")
const _hoisted_616 = /*#__PURE__*/_createTextVNode(" 同會員資料 ")
const _hoisted_617 = { class: "bg-white rounded-md py-[36px] px-[24px] sm:px-[40px]" }
const _hoisted_618 = { class: "flex gap-3 text-primary-color" }
const _hoisted_619 = /*#__PURE__*/_createTextVNode("使用優惠卷 ")
const _hoisted_620 = { class: "flex items-center" }
const _hoisted_621 = { class: "flex flex-col divide-y-2" }
const _hoisted_622 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_623 = { class: "flex items-center" }
const _hoisted_624 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "訂單金額", -1)
const _hoisted_625 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_626 = { class: "flex" }
const _hoisted_627 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 w-[64px] text-clip font-medium pt-1" }, " 優惠卷 ", -1)
const _hoisted_628 = { class: "grow flex flex-col" }
const _hoisted_629 = {
  key: 0,
  class: "shrink-0 text-right font-medium sm:font-bold pt-1"
}
const _hoisted_630 = {
  key: 0,
  class: "flex text-xs max-w-[200px] text-white bg-primary-color mb-1.5 px-2.5 py-[6px] mx-2.5 rounded-2xl items-center leading-[18px]"
}
const _hoisted_631 = { class: "ml-[5px] w-[16px]" }
const _hoisted_632 = {
  key: 1,
  class: "text-right grow font-medium sm:font-bold pt-1"
}
const _hoisted_633 = { class: "flex items-center" }
const _hoisted_634 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費小計", -1)
const _hoisted_635 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_636 = { class: "flex items-center" }
const _hoisted_637 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費折抵", -1)
const _hoisted_638 = {
  key: 0,
  class: "flex text-xs text-white bg-primary-color px-2.5 py-[6px] mx-2.5 rounded-2xl items-center leading-[18px]"
}
const _hoisted_639 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_640 = { class: "pt-[20px]" }
const _hoisted_641 = { class: "flex text-black-900-color leading-[23px] items-center" }
const _hoisted_642 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_643 = { class: "grow text-lg text-right font-bold" }
const _hoisted_644 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 願意收到活動與優惠相關內容 ", -1)
const _hoisted_645 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 我同意辦理退貨時，由HORLaY代為處理電子發票及銷貨退回證明單，以加快退貨退款作業 ", -1)
const _hoisted_646 = /*#__PURE__*/_createElementVNode("div", { class: "text-[11px] tracking-[.12em] text-breadcrumb-color leading-[18px]" }, " 我已確認以上資訊正確無誤。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ui = _resolveComponent("ui")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_Input = _resolveComponent("Input")!
  const _component_AddressInput = _resolveComponent("AddressInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AddOnModal = _resolveComponent("AddOnModal")!
  const _component_DeliveryListModal = _resolveComponent("DeliveryListModal")!
  const _component_SelectCouponModal = _resolveComponent("SelectCouponModal")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", {
          class: _normalizeClass(["tab first:ml-0", [{ actived: _ctx.step === 1 }]])
        }, " 01 購物車 ", 2),
        _hoisted_4,
        _createElementVNode("li", {
          class: _normalizeClass(["tab", [{ actived: _ctx.step === 2 }]])
        }, "02 運送資料&結帳", 2),
        _hoisted_5,
        _createElementVNode("li", {
          class: _normalizeClass(["tab", [{ actived: _ctx.step === 3 }]])
        }, "03 購物完成", 2)
      ]),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_CheckBox, {
              modelValue: _ctx.getAllSelectValue,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allItemSelect(_ctx.getAllSelectValue))),
              class: "pr-2.5"
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.step == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderShoppingCartCmdyListRef, (shoppingCartItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: shoppingCartItem.OrderShoppingCartId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_CheckBox, {
                            modelValue: shoppingCartItem.Checked,
                            "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_15),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem)),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 1),
                              (!shoppingCartItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                        _hoisted_24,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                        _hoisted_26,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_27,
                                        _hoisted_28,
                                        _hoisted_29
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_18),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_InputWithButton, {
                                maxNumber: 100,
                                modelValue: shoppingCartItem.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addClick(shoppingCartItem)),
                                onSubtractClick: ($event: any) => (_ctx.subtractClick(shoppingCartItem)),
                                onBlur: ($event: any) => (_ctx.itemUpdate(shoppingCartItem))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_31, [
                                (
                            shoppingCartItem.UnitFeeOri !==
                            shoppingCartItem.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeOri * shoppingCartItem.CmdyQty), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_33, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                (!shoppingCartItem.IsEndProduct)
                                  ? (_openBlock(), _createBlock(_component_Icon, {
                                      key: 0,
                                      iconName: "circle_edit",
                                      onClick: ($event: any) => (_ctx.continueEdit(shoppingCartItem)),
                                      width: '20px'
                                    }, null, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_FavoriteButton, {
                                  onClick: ($event: any) => (_ctx.addToCollect(shoppingCartItem)),
                                  isLike: !!shoppingCartItem.IsInCmdyCollect,
                                  width: '20px',
                                  iconType: 'circle'
                                }, null, 8, ["onClick", "isLike"]),
                                _createVNode(_component_Icon, {
                                  iconName: "circle_close",
                                  onClick: ($event: any) => (
                            _ctx.itemDelete(shoppingCartItem.OrderShoppingCartId)
                          ),
                                  width: '20px'
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_UnderLine, { class: "w-auto ml-0 mb-5" }),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'package',
                                        width: '20px'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_41, " 禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createVNode(_component_SquareItemFullImage, {
                                        width: '80px',
                                        customClass: ''
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_44, _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                    (_ctx.step == 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "hidden w-[32px] text-xs text-primary-color cursor-pointer",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                        }, "編輯"))
                                      : _createCommentVNode("", true),
                                    _hoisted_45
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal), 1),
                                  _hoisted_48
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", _hoisted_50, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: addOnCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", _hoisted_57, [
                                          _createElementVNode("div", _hoisted_58, [
                                            _createVNode(_component_Icon, {
                                              iconName: 'add_on',
                                              width: '20px'
                                            })
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  addOnCmdyItem.CmdyQty === 0
                              }])
                                          }, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_59, [
                                          _createVNode(_component_ui, { class: "list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                            default: _withCtx(() => [
                                              _hoisted_60,
                                              _hoisted_61
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "text-xs text-primary-color cursor-pointer",
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                              }, "編輯"))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_62, [
                                        _createVNode(_component_InputWithButton, {
                                          maxNumber: addOnCmdyItem.MaxAddOnQtyPerOrder,
                                          modelValue: addOnCmdyItem.CmdyQty,
                                          "onUpdate:modelValue": ($event: any) => ((addOnCmdyItem.CmdyQty) = $event),
                                          onAddClick: ($event: any) => (_ctx.addClick(addOnCmdyItem)),
                                          onSubtractClick: ($event: any) => (_ctx.subtractClick(addOnCmdyItem)),
                                          onBlur: ($event: any) => (_ctx.itemUpdate(addOnCmdyItem))
                                        }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                        _createElementVNode("div", _hoisted_63, [
                                          (
                                addOnCmdyItem.UnitFeeOri !==
                                addOnCmdyItem.UnitFeeReal
                              )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeOri * addOnCmdyItem.CmdyQty), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_65, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                          _createVNode(_component_Icon, {
                                            iconName: "circle_close",
                                            onClick: ($event: any) => (
                                _ctx.itemDelete(
                                  addOnCmdyItem.OrderShoppingCartId,
                                  'addOn'
                                )
                              ),
                                            width: '20px'
                                          }, null, 8, ["onClick"])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex py-[20px]"])
                                }, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_70, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("div", _hoisted_75, [
                                            _createVNode(_component_Icon, {
                                              iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                              width: '20px'
                                            }, null, 8, ["iconName"])
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_76, [
                                          _createVNode(_component_ui, { class: "list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                            default: _withCtx(() => [
                                              _hoisted_77,
                                              _hoisted_78
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "text-xs text-primary-color cursor-pointer",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                              }, "編輯"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass([[
                              {
                                hidden: giveawayCmdyItem.IsOutOfStock === false
                              }
                            ], "flex ml-[26px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                        }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                      ]),
                                      _createElementVNode("div", _hoisted_79, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[60px] font-medium text-gary-text-color text-base text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_80, [
                                          (
                                giveawayCmdyItem.UnitFeeOri !==
                                giveawayCmdyItem.UnitFeeReal
                              )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, " NT. " + _toDisplayString(giveawayCmdyItem.UnitFeeOri), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-left", [
                                {
                                  'text-black-400-color':
                                    giveawayCmdyItem.CmdyQty === 0
                                }
                              ]])
                                          }, " NT. " + _toDisplayString(giveawayCmdyItem.UnitFeeReal * giveawayCmdyItem.CmdyQty), 3)
                                        ]),
                                        (_ctx.step == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _createVNode(_component_Icon, {
                                                class: "hidden",
                                                iconName: "circle_close",
                                                width: '20px'
                                              })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount +
                    _ctx.getListAmount(shoppingCartItem.AddOnCmdyList) +
                    _ctx.getListAmount(shoppingCartItem.PackageCmdyList)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createVNode(_component_CheckBox, {
                            modelValue: shoppingCartItem.Checked,
                            "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_89),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createElementVNode("div", {
                                    class: "text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 9, _hoisted_95),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 9, _hoisted_96),
                                  (!shoppingCartItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_98, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                            _hoisted_100,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                            _hoisted_102,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_103,
                                            _hoisted_104,
                                            _hoisted_105
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                      (!shoppingCartItem.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(shoppingCartItem)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        onClick: ($event: any) => (_ctx.addToCollect(shoppingCartItem)),
                                        isLike: !!shoppingCartItem.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(shoppingCartItem.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_107, [
                              _createVNode(_component_InputWithButton, {
                                modelValue: shoppingCartItem.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addClick(shoppingCartItem)),
                                onSubtractClick: ($event: any) => (_ctx.subtractClick(shoppingCartItem)),
                                onBlur: ($event: any) => (_ctx.itemUpdate(shoppingCartItem))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_108, [
                                (
                            shoppingCartItem.UnitFeeOri !==
                            shoppingCartItem.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeOri * shoppingCartItem.CmdyQty), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_110, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1)
                              ])
                            ])
                          ]),
                          (shoppingCartItem.PackageCmdyList.length !== 0)
                            ? (_openBlock(), _createBlock(_component_UnderLine, {
                                key: 0,
                                class: "hidden w-auto ml-1"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                            _hoisted_112,
                            _createElementVNode("div", _hoisted_113, [
                              _createVNode(_component_SquareItemFullImage, {
                                width: '60px',
                                customClass: 'square-photo-content-no-cursor'
                              })
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("div", _hoisted_117, [
                                    _createElementVNode("div", _hoisted_118, [
                                      _createElementVNode("div", _hoisted_119, [
                                        _createVNode(_component_Icon, {
                                          class: "mr-1.5",
                                          iconName: "package",
                                          width: '20px'
                                        }),
                                        _createTextVNode("禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_120, [
                                        _createElementVNode("div", _hoisted_121, _toDisplayString(shoppingCartItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                        (_ctx.step == 1)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "hidden w-[32px] text-xs text-primary-color cursor-pointer",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('squareItemEditBtnClick')))
                                            }, "編輯"))
                                          : _createCommentVNode("", true),
                                        _hoisted_122
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_123, [
                                  _createElementVNode("div", _hoisted_124, [
                                    (
                            shoppingCartItem.PackageCmdyList[0].UnitFeeOri !==
                            shoppingCartItem.PackageCmdyList[0].UnitFeeReal
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_125, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeOri), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_126, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", _hoisted_128, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_129))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_130))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_131, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: addOnCmdyItem.CmdyImage.MobileWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, [
                                      _createElementVNode("div", _hoisted_134, [
                                        _createElementVNode("div", _hoisted_135, [
                                          _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("div", _hoisted_137, [
                                              _createElementVNode("div", _hoisted_138, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 'add_on',
                                                  width: '20px'
                                                })
                                              ]),
                                              _createElementVNode("span", _hoisted_139, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                            ]),
                                            _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                              default: _withCtx(() => [
                                                _hoisted_140,
                                                _hoisted_141
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                                _createVNode(_component_Icon, {
                                                  iconName: "circle_close",
                                                  onClick: ($event: any) => (
                                  _ctx.itemDelete(
                                    shoppingCartItem.OrderShoppingCartId
                                  )
                                ),
                                                  width: '20px'
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_143, [
                                        _createVNode(_component_InputWithButton, {
                                          modelValue: addOnCmdyItem.CmdyQty,
                                          "onUpdate:modelValue": ($event: any) => ((addOnCmdyItem.CmdyQty) = $event),
                                          onAddClick: ($event: any) => (_ctx.addClick(addOnCmdyItem)),
                                          onSubtractClick: ($event: any) => (_ctx.subtractClick(addOnCmdyItem)),
                                          onBlur: ($event: any) => (_ctx.itemUpdate(addOnCmdyItem))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                        _createElementVNode("div", _hoisted_144, [
                                          _createElementVNode("div", _hoisted_145, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeOri * addOnCmdyItem.CmdyQty), 1),
                                          _createElementVNode("div", _hoisted_146, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px] flex-row pt-5 pb-5"])
                                }, [
                                  (_ctx.step == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_148))
                                    : _createCommentVNode("", true),
                                  (_ctx.step != 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_149))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_150, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("div", _hoisted_152, [
                                      _createElementVNode("div", _hoisted_153, [
                                        _createElementVNode("div", _hoisted_154, [
                                          _createElementVNode("div", _hoisted_155, [
                                            _createElementVNode("div", _hoisted_156, [
                                              _createElementVNode("div", _hoisted_157, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 
                                      giveawayCmdyItem.CmdyQty == 0
                                        ? 'giveaway_gray'
                                        : 'giveaway_black'
                                    ,
                                                  width: '20px'
                                                }, null, 8, ["iconName"])
                                              ]),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                    'text-black-400-color':
                                      giveawayCmdyItem.CmdyQty === 0
                                  }])
                                              }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                            ]),
                                            _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                              default: _withCtx(() => [
                                                _hoisted_158,
                                                _hoisted_159
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("span", {
                                              class: _normalizeClass([[
                                  {
                                    hidden:
                                      giveawayCmdyItem.IsOutOfStock === false
                                  }
                                ], "flex ml-[26px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                            }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                          ]),
                                          (_ctx.step == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                                _createVNode(_component_Icon, {
                                                  class: "hidden",
                                                  iconName: "circle_close",
                                                  width: '20px'
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_161, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[110px] font-medium text-gary-text-color text-base text-center", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_162, [
                                          _createElementVNode("div", _hoisted_163, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeOri * giveawayCmdyItem.CmdyQty), 1),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal * giveawayCmdyItem.CmdyQty), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("div", _hoisted_165, [
                          _hoisted_166,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount +
                    _ctx.getListAmount(shoppingCartItem.AddOnCmdyList) +
                    _ctx.getListAmount(shoppingCartItem.PackageCmdyList)), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.selectedAvailableAddOnCmdyList?.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createVNode(_component_Icon, {
                          iconName: 'add_on',
                          width: '20px'
                        })
                      ]),
                      _hoisted_169
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAvailableAddOnCmdyList, (availableAddOnCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: availableAddOnCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("div", _hoisted_171, [
                        _createElementVNode("div", _hoisted_172, [
                          _createVNode(_component_CheckBox, {
                            modelValue: availableAddOnCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(availableAddOnCmdy, 'AddOn'))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: availableAddOnCmdy.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_173),
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("div", _hoisted_175, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(availableAddOnCmdy, 'AddOn')),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_177, [
                                _createElementVNode("div", _hoisted_178, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'add_on',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_179, _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdySubName)), 1),
                              (!availableAddOnCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_180, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_181, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_182, [
                                        _hoisted_183,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_184, [
                                        _hoisted_185,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_186,
                                        _hoisted_187,
                                        _hoisted_188
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_176),
                            _createElementVNode("div", _hoisted_189, [
                              _createVNode(_component_InputWithButton, {
                                maxNumber: availableAddOnCmdy.MaxAddOnQtyPerOrder,
                                modelValue: availableAddOnCmdy.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'add')),
                                onSubtractClick: ($event: any) => (
                          _ctx.addOnItemUpdate(availableAddOnCmdy, 'subtract')
                        ),
                                onBlur: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'update'))
                              }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_190, [
                                (
                            availableAddOnCmdy.UnitFeeOri !==
                            availableAddOnCmdy.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_191, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeOri), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_192, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal), 1)
                              ]),
                              _createElementVNode("div", _hoisted_193, [
                                _createVNode(_component_Icon, {
                                  iconName: "circle_close",
                                  onClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'delete')),
                                  width: '20px'
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0 mt-3" }),
                      _createElementVNode("div", _hoisted_194, [
                        _createElementVNode("div", _hoisted_195, [
                          _createVNode(_component_Icon, {
                            iconName: "tag_gold",
                            width: '20px'
                          }),
                          _hoisted_196
                        ]),
                        _createElementVNode("div", _hoisted_197, [
                          _hoisted_198,
                          _createTextVNode(" NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal * availableAddOnCmdy.CmdyQty), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_199, [
                      _createElementVNode("div", _hoisted_200, [
                        _createElementVNode("div", _hoisted_201, [
                          _createVNode(_component_CheckBox, {
                            modelValue: availableAddOnCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.Checked) = $event),
                            class: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: availableAddOnCmdy.CmdyImage.MobileWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_202),
                        _createElementVNode("div", _hoisted_203, [
                          _createElementVNode("div", _hoisted_204, [
                            _createElementVNode("div", _hoisted_205, [
                              _createElementVNode("div", _hoisted_206, [
                                _createElementVNode("div", _hoisted_207, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                                  }, [
                                    _createElementVNode("div", _hoisted_209, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'add_on',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdyName)), 1)
                                  ], 8, _hoisted_208),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(availableAddOnCmdy))
                                  }, _toDisplayString(_ctx.unescapeHTML(availableAddOnCmdy.CmdySubName)), 9, _hoisted_210),
                                  (!availableAddOnCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_211, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(
                                availableAddOnCmdy.EditorPortfolioName
                              )), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_212, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_213, [
                                            _hoisted_214,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_215, [
                                            _hoisted_216,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_217,
                                            _hoisted_218,
                                            _hoisted_219
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                      _createVNode(_component_Icon, {
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.addOnItemUpdate(availableAddOnCmdy, 'delete')
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_221, [
                              _createVNode(_component_InputWithButton, {
                                maxNumber: availableAddOnCmdy.MaxAddOnQtyPerOrder,
                                modelValue: availableAddOnCmdy.CmdyQty,
                                "onUpdate:modelValue": ($event: any) => ((availableAddOnCmdy.CmdyQty) = $event),
                                onAddClick: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'add')),
                                onSubtractClick: ($event: any) => (
                          _ctx.addOnItemUpdate(availableAddOnCmdy, 'subtract')
                        ),
                                onBlur: ($event: any) => (_ctx.addOnItemUpdate(availableAddOnCmdy, 'update'))
                              }, null, 8, ["maxNumber", "modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                              _createElementVNode("div", _hoisted_222, [
                                (
                            availableAddOnCmdy.UnitFeeOri !==
                            availableAddOnCmdy.UnitFeeReal
                          )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_223, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeOri), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_224, " NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                      _createElementVNode("div", _hoisted_225, [
                        _createElementVNode("div", _hoisted_226, [
                          _createVNode(_component_Icon, {
                            iconName: "tag_gold",
                            width: '20px'
                          }),
                          _hoisted_227
                        ]),
                        _createElementVNode("div", _hoisted_228, [
                          _hoisted_229,
                          _createTextVNode(" NT. " + _toDisplayString(availableAddOnCmdy.UnitFeeReal * availableAddOnCmdy.CmdyQty), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.giveawayCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_230, [
                      _createElementVNode("div", _hoisted_231, [
                        _createVNode(_component_Icon, {
                          iconName: 'giveaway_black',
                          width: '20px'
                        })
                      ]),
                      _hoisted_232
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayCmdyListFromCalc, (giveawayCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: giveawayCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_233, [
                      _createElementVNode("div", _hoisted_234, [
                        _hoisted_235,
                        _createElementVNode("div", _hoisted_236, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_237, [
                          _createElementVNode("div", _hoisted_238, [
                            _createElementVNode("div", _hoisted_239, [
                              _createElementVNode("div", _hoisted_240, [
                                _createElementVNode("div", _hoisted_241, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'giveaway_black',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_242, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                              (!giveawayCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_243, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_244, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_245, [
                                        _hoisted_246,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_247, [
                                        _hoisted_248,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_249,
                                        _hoisted_250,
                                        _hoisted_251
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_252, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_253, [
                      _createElementVNode("div", _hoisted_254, [
                        _createElementVNode("div", _hoisted_255, [
                          _createVNode(_component_CheckBox, { class: "hidden" })
                        ]),
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ], 8, _hoisted_256),
                        _createElementVNode("div", _hoisted_257, [
                          _createElementVNode("div", _hoisted_258, [
                            _createElementVNode("div", _hoisted_259, [
                              _createElementVNode("div", _hoisted_260, [
                                _createElementVNode("div", _hoisted_261, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                                  }, [
                                    _createVNode(_component_Icon, {
                                      class: "mr-1.5",
                                      iconName: 'giveaway_black',
                                      width: '20px'
                                    }),
                                    _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                                  ], 8, _hoisted_262),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                                  }, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 9, _hoisted_263),
                                  (!giveawayCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_264, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_265, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_266, [
                                            _hoisted_267,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_268, [
                                            _hoisted_269,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_270,
                                            _hoisted_271,
                                            _hoisted_272
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                                      (!giveawayCmdy.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "hidden",
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(giveawayCmdy)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        class: "hidden",
                                        onClick: ($event: any) => (_ctx.addToCollect(giveawayCmdy)),
                                        isLike: !!giveawayCmdy.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        class: "hidden",
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(giveawayCmdy.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_274, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.step == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_275, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyListFromCalc, (shoppingCartItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_276, [
                      _createElementVNode("div", _hoisted_277, [
                        _hoisted_278,
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_279),
                        _createElementVNode("div", _hoisted_280, [
                          _createElementVNode("div", _hoisted_281, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem)),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_283, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 1),
                              _createElementVNode("div", _hoisted_284, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 1),
                              (!shoppingCartItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_285, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_286, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_287, [
                                        _hoisted_288,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_289, [
                                        _hoisted_290,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_291,
                                        _hoisted_292,
                                        _hoisted_293
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_282),
                            _createElementVNode("div", _hoisted_294, [
                              _createElementVNode("div", _hoisted_295, _toDisplayString(shoppingCartItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_296, [
                                _hoisted_297,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right", [{'line-through text-light-gary-text-color': shoppingCartItem.Discount > 0}]])
                                }, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 3),
                                (shoppingCartItem.Discount > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_298, " NT. " + _toDisplayString((shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty) - shoppingCartItem.Discount), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_299, [
                            _hoisted_300,
                            _hoisted_301,
                            _createElementVNode("div", _hoisted_302, [
                              _createVNode(_component_UnderLine, { class: "w-auto ml-[111px] sm:ml-0 mb-5" }),
                              _createElementVNode("div", _hoisted_303, [
                                _createElementVNode("div", _hoisted_304, [
                                  _createElementVNode("div", _hoisted_305, [
                                    _createElementVNode("div", _hoisted_306, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'package',
                                        width: '20px'
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_307, " 禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_308, [
                                    _createElementVNode("div", _hoisted_309, [
                                      _createVNode(_component_SquareItemFullImage, {
                                        width: '80px',
                                        customClass: ''
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_310, _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                    _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                      default: _withCtx(() => [
                                        _hoisted_311,
                                        _hoisted_312,
                                        _hoisted_313,
                                        _hoisted_314,
                                        _hoisted_315
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_316
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_317, [
                                  _createElementVNode("div", _hoisted_318, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", _hoisted_320, [
                                  _hoisted_321,
                                  _createElementVNode("div", _hoisted_322, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: addOnCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_323, [
                                    _createElementVNode("div", _hoisted_324, [
                                      _createElementVNode("div", _hoisted_325, [
                                        _createElementVNode("div", _hoisted_326, [
                                          _createElementVNode("div", _hoisted_327, [
                                            _createVNode(_component_Icon, {
                                              iconName: 'add_on',
                                              width: '20px'
                                            })
                                          ]),
                                          _createElementVNode("span", _hoisted_328, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_329, [
                                          _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                            default: _withCtx(() => [
                                              _hoisted_330,
                                              _hoisted_331
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_332, [
                                        _createElementVNode("div", _hoisted_333, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                        _createElementVNode("div", _hoisted_334, [
                                          _createElementVNode("div", _hoisted_335, " NT." + _toDisplayString(addOnCmdyItem.UnitFeeReal * addOnCmdyItem.CmdyQty), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_336, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: giveawayCmdyItem.CmdyId,
                                class: "add-on-item"
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px]"])
                                }, [
                                  _hoisted_337,
                                  _createElementVNode("div", _hoisted_338, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: giveawayCmdyItem.CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_339, [
                                    _createElementVNode("div", _hoisted_340, [
                                      _createElementVNode("div", _hoisted_341, [
                                        _createElementVNode("div", _hoisted_342, [
                                          _createElementVNode("div", _hoisted_343, [
                                            _createVNode(_component_Icon, {
                                              iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                              width: '20px'
                                            }, null, 8, ["iconName"])
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_344, [
                                          _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                            default: _withCtx(() => [
                                              _hoisted_345,
                                              _hoisted_346
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", {
                                            class: _normalizeClass([[
                                {
                                  hidden:
                                    giveawayCmdyItem.IsOutOfStock === false
                                }
                              ], "flex ml-[25px] items-center mb-1.5 font-medium text-xs text-dot-red"])
                                          }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_347, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_348, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_349, [
                        _createElementVNode("div", _hoisted_350, [
                          _hoisted_351,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_352, [
                      _createElementVNode("div", _hoisted_353, [
                        _hoisted_354,
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: shoppingCartItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_355),
                        _createElementVNode("div", _hoisted_356, [
                          _createElementVNode("div", _hoisted_357, [
                            _createElementVNode("div", _hoisted_358, [
                              _createElementVNode("div", _hoisted_359, [
                                _createElementVNode("div", _hoisted_360, [
                                  _createElementVNode("div", {
                                    class: "text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdyName)), 9, _hoisted_361),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.CmdySubName)), 9, _hoisted_362),
                                  (!shoppingCartItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_363, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(shoppingCartItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_364, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_365, [
                                            _hoisted_366,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_367, [
                                            _hoisted_368,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_369,
                                            _hoisted_370,
                                            _hoisted_371
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_372, [
                              _createElementVNode("div", _hoisted_373, _toDisplayString(shoppingCartItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_374, [
                                _createElementVNode("div", _hoisted_375, [
                                  _createElementVNode("div", _hoisted_376, " NT. " + _toDisplayString(shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty), 1),
                                  (shoppingCartItem.Discount > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_377, " NT. " + _toDisplayString((shoppingCartItem.UnitFeeReal * shoppingCartItem.CmdyQty) - shoppingCartItem.Discount), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          (shoppingCartItem.PackageCmdyList?.length !== 0)
                            ? (_openBlock(), _createBlock(_component_UnderLine, {
                                key: 0,
                                class: "hidden w-auto ml-1"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (shoppingCartItem.PackageCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_378, [
                            _hoisted_379,
                            _createElementVNode("div", _hoisted_380, [
                              _createVNode(_component_SquareItemFullImage, {
                                width: '60px',
                                customClass: ''
                              })
                            ]),
                            _createElementVNode("div", _hoisted_381, [
                              _createElementVNode("div", _hoisted_382, [
                                _createElementVNode("div", _hoisted_383, [
                                  _createElementVNode("div", _hoisted_384, [
                                    _createElementVNode("div", _hoisted_385, [
                                      _createElementVNode("div", _hoisted_386, [
                                        _createVNode(_component_Icon, {
                                          class: "mr-1.5",
                                          iconName: "package",
                                          width: '20px'
                                        }),
                                        _createTextVNode("禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_387, [
                                        _createElementVNode("div", _hoisted_388, _toDisplayString(shoppingCartItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                        _hoisted_389
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_390, [
                                  _createElementVNode("div", _hoisted_391, [
                                    _createElementVNode("div", _hoisted_392, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createBlock(_component_UnderLine, {
                            key: 1,
                            class: "w-auto m-0"
                          }))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.AddOnCmdyList?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_393, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: addOnCmdyItem.CmdyId,
                                class: ""
                              }, [
                                _createElementVNode("div", _hoisted_394, [
                                  _hoisted_395,
                                  _createElementVNode("div", _hoisted_396, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      customClass: '',
                                      image: addOnCmdyItem.CmdyImage.MobileWeb
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_397, [
                                    _createElementVNode("div", _hoisted_398, [
                                      _createElementVNode("div", _hoisted_399, [
                                        _createElementVNode("div", _hoisted_400, [
                                          _createElementVNode("div", _hoisted_401, [
                                            _createElementVNode("div", _hoisted_402, [
                                              _createVNode(_component_Icon, {
                                                class: "mr-1.5",
                                                iconName: "add_on",
                                                width: '20px'
                                              }),
                                              _createTextVNode(" 加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                            ]),
                                            _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                              default: _withCtx(() => [
                                                _hoisted_403,
                                                _hoisted_404
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_405, [
                                        _createElementVNode("div", _hoisted_406, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                        _createElementVNode("div", _hoisted_407, [
                                          _createElementVNode("div", _hoisted_408, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (shoppingCartItem.GiveawayCmdyList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_409, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "flex flex-row",
                                key: giveawayCmdyItem.CmdyId
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px] flex-row pt-5 pb-5"])
                                }, [
                                  _hoisted_410,
                                  _createElementVNode("div", _hoisted_411, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '60px',
                                      image: giveawayCmdyItem.CmdyImage.MobileWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_412, [
                                    _createElementVNode("div", _hoisted_413, [
                                      _createElementVNode("div", _hoisted_414, [
                                        _createElementVNode("div", _hoisted_415, [
                                          _createElementVNode("div", _hoisted_416, [
                                            _createElementVNode("div", _hoisted_417, [
                                              _createElementVNode("div", _hoisted_418, [
                                                _createVNode(_component_Icon, {
                                                  iconName: 
                                      giveawayCmdyItem.CmdyQty == 0
                                        ? 'giveaway_gray'
                                        : 'giveaway_black'
                                    ,
                                                  width: '20px'
                                                }, null, 8, ["iconName"])
                                              ]),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                    'text-black-400-color':
                                      giveawayCmdyItem.CmdyQty === 0
                                  }])
                                              }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                            ]),
                                            _createVNode(_component_ui, { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, {
                                              default: _withCtx(() => [
                                                _hoisted_419,
                                                _hoisted_420
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("div", {
                                              class: _normalizeClass([[
                                  {
                                    hidden:
                                      giveawayCmdyItem.IsOutOfStock === false
                                  }
                                ], "flex items-center mb-1.5 font-medium text-xs text-dot-red"])
                                            }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_421, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                        _createElementVNode("div", _hoisted_422, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                          }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal), 3)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_423, [
                        _createElementVNode("div", _hoisted_424, [
                          _hoisted_425,
                          _createTextVNode(" NT. " + _toDisplayString(shoppingCartItem.TotalAmount), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.addOnCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_426, [
                      _createVNode(_component_Icon, {
                        class: "mr-2.5",
                        iconName: 'add_on',
                        width: '20px'
                      }),
                      _hoisted_427
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addOnCmdyListFromCalc, (addOnCmdyItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_428, [
                      _createElementVNode("div", _hoisted_429, [
                        _hoisted_430,
                        _createElementVNode("div", {
                          class: "w-[80px]",
                          onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn'))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: addOnCmdyItem.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_431),
                        _createElementVNode("div", _hoisted_432, [
                          _createElementVNode("div", _hoisted_433, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn')),
                              class: "flex flex-col gap-1 w-[46%] cursor-pointer"
                            }, [
                              _createElementVNode("div", _hoisted_435, [
                                _createElementVNode("div", _hoisted_436, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'add_on',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_437, _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdySubName)), 1),
                              (!addOnCmdyItem.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_438, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_439, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_440, [
                                        _hoisted_441,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_442, [
                                        _hoisted_443,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_444,
                                        _hoisted_445,
                                        _hoisted_446
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_434),
                            _createElementVNode("div", _hoisted_447, [
                              _createElementVNode("div", _hoisted_448, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_449, [
                                _createElementVNode("div", _hoisted_450, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_451, [
                        _createElementVNode("div", _hoisted_452, [
                          _hoisted_453,
                          _createTextVNode(" NT. " + _toDisplayString(addOnCmdyItem.TotalAmount), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_454, [
                      _createElementVNode("div", _hoisted_455, [
                        _hoisted_456,
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: addOnCmdyItem.CmdyImage.MobileWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_457),
                        _createElementVNode("div", _hoisted_458, [
                          _createElementVNode("div", _hoisted_459, [
                            _createElementVNode("div", _hoisted_460, [
                              _createElementVNode("div", _hoisted_461, [
                                _createElementVNode("div", _hoisted_462, [
                                  _createElementVNode("div", {
                                    class: "flex text-[13px] font-medium text-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                                  }, [
                                    _createElementVNode("div", _hoisted_464, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'add_on',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdyName)), 1)
                                  ], 8, _hoisted_463),
                                  _createElementVNode("div", {
                                    class: "text-xs leading-5 text-light-gary-text-color",
                                    onClick: ($event: any) => (_ctx.goProductDetail(addOnCmdyItem))
                                  }, _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.CmdySubName)), 9, _hoisted_465),
                                  (!addOnCmdyItem.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_466, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnCmdyItem.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_467, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_468, [
                                            _hoisted_469,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_470, [
                                            _hoisted_471,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_472,
                                            _hoisted_473,
                                            _hoisted_474
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_475, [
                              _createElementVNode("div", _hoisted_476, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                              _createElementVNode("div", _hoisted_477, [
                                _createElementVNode("div", _hoisted_478, " NT. " + _toDisplayString(addOnCmdyItem.UnitFeeReal), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_479, [
                        _createElementVNode("div", _hoisted_480, [
                          _hoisted_481,
                          _createTextVNode(" NT. " + _toDisplayString(addOnCmdyItem.TotalAmount), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.giveawayCmdyListFromCalc.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_482, [
                      _createVNode(_component_Icon, {
                        class: "mr-2.5",
                        iconName: 'giveaway_black',
                        width: '20px'
                      }),
                      _hoisted_483
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayCmdyListFromCalc, (giveawayCmdy) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: giveawayCmdy.CmdyId,
                    class: "flex flex-col gap-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_484, [
                      _createElementVNode("div", _hoisted_485, [
                        _createElementVNode("div", _hoisted_486, [
                          _createVNode(_component_CheckBox, {
                            modelValue: giveawayCmdy.Checked,
                            "onUpdate:modelValue": ($event: any) => ((giveawayCmdy.Checked) = $event),
                            class: "hidden"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_487, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: 'square-photo-content-no-cursor'
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_488, [
                          _createElementVNode("div", _hoisted_489, [
                            _createElementVNode("div", _hoisted_490, [
                              _createElementVNode("div", _hoisted_491, [
                                _createElementVNode("div", _hoisted_492, [
                                  _createVNode(_component_Icon, {
                                    iconName: 'giveaway_black',
                                    width: '20px'
                                  })
                                ]),
                                _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_493, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                              (!giveawayCmdy.IsEndProduct)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_494, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_495, [
                                _createElementVNode("div", {
                                  class: "text-xs text-primary-color cursor-pointer",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                }, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_496, [
                                        _hoisted_497,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_498, [
                                        _hoisted_499,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.detail)
                                  ? (_openBlock(), _createBlock(_component_ui, {
                                      key: 0,
                                      class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_500,
                                        _hoisted_501,
                                        _hoisted_502
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_503, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_504, [
                      _createElementVNode("div", _hoisted_505, [
                        _createElementVNode("div", {
                          class: "w-[60px]",
                          onClick: ($event: any) => (_ctx.goProductDetail(giveawayCmdy))
                        }, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '60px',
                            image: giveawayCmdy.CmdyImage.PcWeb,
                            customClass: ''
                          }, null, 8, ["image"])
                        ], 8, _hoisted_506),
                        _createElementVNode("div", _hoisted_507, [
                          _createElementVNode("div", _hoisted_508, [
                            _createElementVNode("div", _hoisted_509, [
                              _createElementVNode("div", _hoisted_510, [
                                _createElementVNode("div", _hoisted_511, [
                                  _createElementVNode("div", _hoisted_512, [
                                    _createElementVNode("div", _hoisted_513, [
                                      _createVNode(_component_Icon, {
                                        iconName: 'giveaway_black',
                                        width: '20px'
                                      })
                                    ]),
                                    _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdyName)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_514, _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.CmdySubName)), 1),
                                  (!giveawayCmdy.IsEndProduct)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_515, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(giveawayCmdy.EditorPortfolioName)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_516, [
                                    _createElementVNode("div", {
                                      class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                    }, [
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_517, [
                                            _hoisted_518,
                                            (!_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_down",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.detail)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_519, [
                                            _hoisted_520,
                                            (_ctx.detail)
                                              ? (_openBlock(), _createBlock(_component_Icon, {
                                                  key: 0,
                                                  iconName: "arrow_up",
                                                  width: '12px'
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.detail)
                                      ? (_openBlock(), _createBlock(_component_ui, {
                                          key: 0,
                                          class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_521,
                                            _hoisted_522,
                                            _hoisted_523
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (_ctx.step == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_524, [
                                      (!giveawayCmdy.IsEndProduct)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "hidden",
                                            iconName: "circle_edit",
                                            onClick: ($event: any) => (_ctx.continueEdit(giveawayCmdy)),
                                            width: '20px'
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_FavoriteButton, {
                                        class: "hidden",
                                        onClick: ($event: any) => (_ctx.addToCollect(giveawayCmdy)),
                                        isLike: !!giveawayCmdy.IsInCmdyCollect,
                                        width: '20px',
                                        iconType: 'circle'
                                      }, null, 8, ["onClick", "isLike"]),
                                      _createVNode(_component_Icon, {
                                        class: "hidden",
                                        iconName: "circle_close",
                                        onClick: ($event: any) => (
                              _ctx.itemDelete(giveawayCmdy.OrderShoppingCartId)
                            ),
                                        width: '20px'
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_525, _toDisplayString(giveawayCmdy.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.step == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_526, [
              _createElementVNode("div", _hoisted_527, [
                _createElementVNode("div", _hoisted_528, [
                  _createElementVNode("div", _hoisted_529, [
                    _createElementVNode("div", _hoisted_530, [
                      _hoisted_531,
                      _createElementVNode("div", _hoisted_532, " NT. " + _toDisplayString(_ctx.getSelectPrice.CmdyAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_533, [
                      _hoisted_534,
                      _createElementVNode("div", _hoisted_535, " - NT. " + _toDisplayString(_ctx.getSelectPrice.Discount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_536, [
                    _createElementVNode("div", _hoisted_537, [
                      _hoisted_538,
                      _createElementVNode("div", _hoisted_539, " NT. " + _toDisplayString(_ctx.getSelectPrice.CmdyAmt - _ctx.getSelectPrice.Discount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_540, [
                      _createElementVNode("div", {
                        class: "bg-primary-color h-2 rounded-full",
                        style: _normalizeStyle({ width: `${_ctx.getSelectPrice.ForFree}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("div", {
                      class: "pt-[11px] text-xs text-gary-text-color tracking-[.08em] font-bold whitespace-pre-wrap leading-5",
                      innerHTML: _ctx.getSelectPrice.ForFreeDesc
                    }, null, 8, _hoisted_541),
                    _createElementVNode("div", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.router.push({ name: 'home' }))),
                      class: "text-gary-text-color font-medium sm:font-bold my-[20px] cursor-pointer"
                    }, " < 繼續購物 "),
                    _createElementVNode("div", {
                      class: _normalizeClass(["leading-[50px] text-center bg-gary-text-color text-white rounded-[10px] text-base cursor-pointer hover:bg-primary-color active:bg-primary-color", {
                  'cursor-not-allowed': _ctx.getSelectedItem.length === 0,
                  'hover:bg-gary-text-color': _ctx.getSelectedItem.length === 0,
                  'active:bg-gary-text-color': _ctx.getSelectedItem.length === 0
                }]),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getSelectedItem.length !== 0 && _ctx.goStep(2)))
                    }, " 去結帳 ", 2)
                  ])
                ])
              ]),
              (_ctx.availableAddOnCmdyListFromCalc.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_542, [
                    _hoisted_543,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableAddOnCmdyListFromCalc, (addOnCmdyItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-row cursor-pointer",
                        key: addOnCmdyItem.CmdyId,
                        onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(addOnCmdyItem, 'AddOn'))
                      }, [
                        _createElementVNode("div", _hoisted_545, [
                          _createVNode(_component_SquareItemFullImage, {
                            width: '80px',
                            class: "pr-2",
                            customClass: '',
                            image: addOnCmdyItem.CmdyImage.PcWeb
                          }, null, 8, ["image"])
                        ]),
                        _createElementVNode("div", _hoisted_546, [
                          _createElementVNode("div", _hoisted_547, [
                            _createElementVNode("div", _hoisted_548, _toDisplayString(addOnCmdyItem.CmdyName), 1),
                            _createElementVNode("div", _hoisted_549, [
                              _hoisted_550,
                              _createElementVNode("span", null, _toDisplayString(addOnCmdyItem.UnitFeeReal), 1),
                              (
                      addOnCmdyItem.UnitFeeReal !== addOnCmdyItem.UnitFeeOri
                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_551, [
                                    _hoisted_552,
                                    _createElementVNode("span", null, _toDisplayString(addOnCmdyItem.UnitFeeOri), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_553, [
                            _createVNode(_component_Icon, {
                              onClick: _withModifiers(($event: any) => (_ctx.addAddOn(addOnCmdyItem)), ["stop"]),
                              iconName: "circle_add",
                              width: '30px'
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ], 8, _hoisted_544))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_554, [
                _hoisted_555,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendedList, (recommendedItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex flex-row cursor-pointer",
                    key: recommendedItem,
                    onClick: ($event: any) => (_ctx.goProductDetail(recommendedItem))
                  }, [
                    _createElementVNode("div", _hoisted_557, [
                      _createVNode(_component_SquareItemFullImage, {
                        width: '80px',
                        class: "pr-2",
                        customClass: '',
                        image: recommendedItem.Image.PcWeb
                      }, null, 8, ["image"])
                    ]),
                    _createElementVNode("div", _hoisted_558, [
                      _createElementVNode("div", _hoisted_559, [
                        _createElementVNode("div", _hoisted_560, _toDisplayString(recommendedItem.Name), 1),
                        _createElementVNode("div", _hoisted_561, _toDisplayString(recommendedItem.SubName), 1),
                        _createElementVNode("div", _hoisted_562, [
                          _hoisted_563,
                          _createElementVNode("span", null, _toDisplayString(recommendedItem.UnitFeeReal), 1),
                          (
                      recommendedItem.UnitFeeReal !== recommendedItem.UnitFeeOri
                    )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_564, [
                                _hoisted_565,
                                _createElementVNode("span", null, _toDisplayString(recommendedItem.UnitFeeOri), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_566, [
                        _createVNode(_component_Icon, {
                          iconName: "circle_add",
                          width: '30px'
                        })
                      ])
                    ])
                  ], 8, _hoisted_556))
                }), 128)),
                _createElementVNode("div", {
                  class: "cursor-pointer text-center items-center m-auto rounded-[10px] h-[39px] w-[139px] leading-[35px] border-[1px] tracking-[.1em] border-gary-text-color text-gary-text-color text-sm",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goIpInspiration()))
                }, " View More ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.step == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_567, [
              _createElementVNode("div", _hoisted_568, [
                _createElementVNode("div", _hoisted_569, [
                  _hoisted_570,
                  _createVNode(_component_Input, {
                    label: '姓名',
                    class: "under-line mb-5",
                    width: '100%',
                    required: true,
                    placeholder: "請輸入姓名",
                    modelValue: _ctx.buyerName,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.buyerName) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_571, [
                    _hoisted_572,
                    _createElementVNode("div", _hoisted_573, _toDisplayString(_ctx.store.state.userInfo.Mobile), 1)
                  ]),
                  _createVNode(_component_Input, {
                    label: 'E-mail',
                    class: "under-line pb-1",
                    width: '100%',
                    required: true,
                    placeholder: "請輸入email",
                    modelValue: _ctx.buyerEmail,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.buyerEmail) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_574,
                  _createVNode(_component_AddressInput, {
                    deliveryAddr: _ctx.buyerAddr,
                    "onUpdate:deliveryAddr": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.buyerAddr) = $event)),
                    deliveryDist: _ctx.buyerDist,
                    "onUpdate:deliveryDist": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.buyerDist) = $event)),
                    deliveryCity: _ctx.buyerCity,
                    "onUpdate:deliveryCity": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.buyerCity) = $event)),
                    deliveryZip: _ctx.buyerZip,
                    "onUpdate:deliveryZip": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.buyerZip) = $event)),
                    required: true,
                    label: '地址'
                  }, null, 8, ["deliveryAddr", "deliveryDist", "deliveryCity", "deliveryZip"])
                ])
              ]),
              _createElementVNode("div", _hoisted_575, [
                _createElementVNode("div", _hoisted_576, [
                  _createElementVNode("div", _hoisted_577, [
                    _hoisted_578,
                    (_ctx.selectDeliveryType === 'EcPayCVS')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_579, " ・超商取貨需出示證件，請確實填寫。 "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Select, {
                    class: "my-3 w-full",
                    width: '100%',
                    itemList: _ctx.cartStore.state.deliveryTypeList,
                    itemValue: 'Code',
                    itemText: 'Desc',
                    modelValue: _ctx.selectDeliveryType,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectDeliveryType) = $event)),
                    onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.getFreight(_ctx.selectDeliveryType)))
                  }, null, 8, ["itemList", "modelValue"]),
                  _createElementVNode("div", {
                    class: "w-full hover:border-black active:border-black justify-between h-[100px] flex mb-2.5 pl-[16px] py-[16px] rounded-[4px] border-black-300-color border-solid border-[1px] cursor-pointer",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.goDeliveryListModal()))
                  }, [
                    (
                  _ctx.cartStore.state.shoppingCartDetailInfo.Delivery !==
                    undefined &&
                  (_ctx.selectDeliveryType === 'Home' ||
                    _ctx.selectDeliveryType === 'GainHowShopSeller')
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_580, [
                          _createElementVNode("div", _hoisted_581, [
                            _createElementVNode("div", _hoisted_582, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .ReceiverName), 1),
                            _createElementVNode("div", _hoisted_583, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .ReceiverMobile), 1)
                          ]),
                          (_ctx.selectDeliveryType === 'Home')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_584, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                      .DeliveryCity +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                      .DeliveryDist +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery.DeliveryAddr), 1))
                            : (_ctx.selectDeliveryType === 'GainHowShopSeller')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_585, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery.ShopInfo
                      .ShopName +
                    ' ' +
                    _ctx.cartStore.state.shoppingCartDetailInfo.Delivery.ShopInfo
                      .ShopAddr), 1))
                              : _createCommentVNode("", true)
                        ]))
                      : (
                  _ctx.selectDeliverySubType !== '' &&
                  _ctx.selectDeliveryType === 'EcPayCVS' &&
                  _ctx.cartStore.state.shoppingCartDetailInfo.Receiver !==
                    undefined &&
                  _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                    .ReceiverName !== ''
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_586, [
                            _createElementVNode("div", _hoisted_587, [
                              _createElementVNode("div", _hoisted_588, _toDisplayString(_ctx.selectDeliverySubTypeDesc), 1),
                              _createElementVNode("div", _hoisted_589, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Delivery
                        .DeliveryDestName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_590, [
                              _createElementVNode("div", _hoisted_591, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverName || ''), 1)
                            ]),
                            _createElementVNode("div", _hoisted_592, [
                              _createElementVNode("div", _hoisted_593, _toDisplayString(_ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverMobile), 1),
                              (
                      _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverTel !== ''
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_594, _toDisplayString('/ ' +
                      _ctx.cartStore.state.shoppingCartDetailInfo.Receiver
                        .ReceiverTel), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_ctx.selectDeliveryType === 'EcPayCVS')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_595, " 選擇門市資訊 "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_596, " 填寫收件資料 ")),
                    _createElementVNode("div", _hoisted_597, [
                      _createVNode(_component_Icon, {
                        iconName: "arrow_right",
                        width: '24px'
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_598, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "block px-[16px] py-[7px] w-full h-[80px] text-[13px] tracking-[.12em] text-gary-text-color placeholder:font-medium placeholder:text-black-400-color placeholder:tracking-[0.12em] rounded-md resize-none",
                      placeholder: "請輸入訂單備註",
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.remark) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.remark]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_599, [
                _createElementVNode("div", _hoisted_600, [
                  _hoisted_601,
                  _createElementVNode("div", _hoisted_602, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore.state.paymentTypeList, (paymentItem) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: paymentItem.Code,
                        text: paymentItem.Desc,
                        width: '20px',
                        inputValue: paymentItem,
                        modelValue: _ctx.selectPaymentType,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectPaymentType) = $event))
                      }, null, 8, ["text", "inputValue", "modelValue"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_603, [
                  _hoisted_604,
                  _createVNode(_component_Select, {
                    class: "my-3 w-full",
                    width: '100%',
                    itemList: _ctx.cartStore.state.invoiceTypeList,
                    itemValue: 'Code',
                    itemText: 'Desc',
                    modelValue: _ctx.selectInvoiceType,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.selectInvoiceType) = $event))
                  }, null, 8, ["itemList", "modelValue"]),
                  (_ctx.selectInvoiceType === 'Elec2')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_605, _hoisted_607))
                    : _createCommentVNode("", true),
                  (_ctx.selectInvoiceType === 'Elec2WithBarcode')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_608, [
                        _createElementVNode("div", _hoisted_609, [
                          _hoisted_610,
                          _createElementVNode("div", {
                            class: "hidden flex items-center text-xs text-breadcrumb-color pl-[24px] tracking-[.1em] font-normal cursor-pointer",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isSameMemberBarcode = !_ctx.isSameMemberBarcode))
                          }, [
                            _createVNode(_component_RadioButton, {
                              width: '12px',
                              inputValue: _ctx.isSameMemberBarcode,
                              modelValue: _ctx.isSameMemberBarcode,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isSameMemberBarcode) = $event))
                            }, null, 8, ["inputValue", "modelValue"]),
                            _hoisted_611
                          ])
                        ]),
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "mail",
                          height: "50px",
                          width: '100%',
                          modelValue: _ctx.invoiceCarrier,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.invoiceCarrier) = $event)),
                          placeholder: '請輸入手機條碼載具'
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectInvoiceType === 'Elec3')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_612, [
                        _hoisted_613,
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "number",
                          height: "50px",
                          width: '100%',
                          placeholder: '請輸入8碼統一編號',
                          modelValue: _ctx.invoiceBizNo,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.invoiceBizNo) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_614, [
                          _hoisted_615,
                          _createElementVNode("div", {
                            class: "flex items-center text-xs text-breadcrumb-color pl-[24px] tracking-[.1em] font-normal cursor-pointer",
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isSameMemberEmail = !_ctx.isSameMemberEmail))
                          }, [
                            _createVNode(_component_RadioButton, {
                              width: '12px',
                              inputValue: _ctx.isSameMemberEmail,
                              modelValue: _ctx.isSameMemberEmail,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isSameMemberEmail) = $event))
                            }, null, 8, ["inputValue", "modelValue"]),
                            _hoisted_616
                          ])
                        ]),
                        _createVNode(_component_Input, {
                          class: "w-full",
                          type: "mail",
                          height: "50px",
                          width: '100%',
                          modelValue: _ctx.invoiceEmail,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.invoiceEmail) = $event)),
                          placeholder: '請輸入E-mail'
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_617, [
                _createElementVNode("div", {
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.goCouponSelectModal && _ctx.goCouponSelectModal(...args))),
                  class: "flex border-[1px] justify-between py-[15px] rounded-xl px-[15px] mb-[16px] cursor-pointer text-right font-medium sm:font-bold tracking-[.1em]"
                }, [
                  _createElementVNode("div", _hoisted_618, [
                    _createVNode(_component_Icon, { iconName: "tag_gold" }),
                    _hoisted_619
                  ]),
                  _createElementVNode("div", _hoisted_620, [
                    _createVNode(_component_Icon, {
                      iconName: "arrow_right",
                      width: '24px'
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_621, [
                  _createElementVNode("div", _hoisted_622, [
                    _createElementVNode("div", _hoisted_623, [
                      _hoisted_624,
                      _createElementVNode("div", _hoisted_625, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.TotalCmdyAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_626, [
                      _hoisted_627,
                      _createElementVNode("div", _hoisted_628, [
                        (_ctx.calcShoppingCartObject.TotalCmdyDiscount === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_629, " - NT. 0 "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calcShoppingCartObject.AppliedPromotionList, (selectCoupon) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: selectCoupon.PromotionCouponId,
                            class: "flex"
                          }, [
                            (selectCoupon.DiscountTarget === 'CmdyAmt')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_630, [
                                  _createTextVNode(_toDisplayString(selectCoupon.PromotionActivityName) + " ", 1),
                                  _createElementVNode("div", _hoisted_631, [
                                    _createVNode(_component_Icon, {
                                      onClick: ($event: any) => (_ctx.cancelCoupon(selectCoupon)),
                                      class: "cursor-pointer",
                                      iconName: "close_white",
                                      width: '16px'
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (selectCoupon.DiscountTarget === 'CmdyAmt')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_632, " - NT. " + _toDisplayString(selectCoupon.Discount), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_633, [
                      _hoisted_634,
                      _createElementVNode("div", _hoisted_635, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.FreightAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_636, [
                      _hoisted_637,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calcShoppingCartObject.AppliedPromotionList, (appliedPromotion) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: appliedPromotion.PromotionActivityId
                        }, [
                          (appliedPromotion.DiscountTarget === 'FreightAmt')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_638, [
                                _createTextVNode(_toDisplayString(appliedPromotion.PromotionActivityName), 1),
                                _createVNode(_component_Icon, {
                                  class: "hidden ml-[5px] cursor-pointer",
                                  iconName: "close_white",
                                  width: '16px'
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_639, " - NT. " + _toDisplayString(_ctx.calcShoppingCartObject.FreightDiscount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_640, [
                    _createElementVNode("div", _hoisted_641, [
                      _hoisted_642,
                      _createElementVNode("div", _hoisted_643, " NT. " + _toDisplayString(_ctx.calcShoppingCartObject.TotalShoppingCartAmount), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex mt-[30px] items-center cursor-pointer",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isAllowReceive = !_ctx.isAllowReceive))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowReceive,
                        modelValue: _ctx.isAllowReceive,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.isAllowReceive) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_644
                    ]),
                    _createElementVNode("div", {
                      class: "flex my-[6px] items-center cursor-pointer",
                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.isAllowReturn = !_ctx.isAllowReturn))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowReturn,
                        modelValue: _ctx.isAllowReturn,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.isAllowReturn) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_645
                    ]),
                    _createElementVNode("div", {
                      class: "flex mb-[30px] items-center cursor-pointer",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isAllowInfoCorrect = !_ctx.isAllowInfoCorrect))
                    }, [
                      _createVNode(_component_RadioButton, {
                        width: '12px',
                        inputValue: _ctx.isAllowInfoCorrect,
                        modelValue: _ctx.isAllowInfoCorrect,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.isAllowInfoCorrect) = $event))
                      }, null, 8, ["inputValue", "modelValue"]),
                      _hoisted_646
                    ]),
                    _createElementVNode("div", {
                      class: "text-gary-text-color text-base font-medium sm:font-bold mt-[30px] mb-[20px] cursor-pointer",
                      onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goStep(1)))
                    }, " < 返回至購物車頁面 "),
                    _createElementVNode("div", {
                      class: "leading-9 sm:leading-[50px] text-center bg-gary-text-color text-white rounded-[10px] text-sm sm:text-base cursor-pointer hover:bg-primary-color active:bg-primary-color",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.order()))
                    }, " 確認付款 ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_AddOnModal, {
      show: _ctx.showAddOnModal,
      cmdyType: _ctx.selectedType,
      AddOnCmdyItem: _ctx.selectAddOnCmdy,
      page: 'shoppingCart',
      onOk: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showAddOnModal = false)),
      onCancel: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showAddOnModal = false))
    }, null, 8, ["show", "cmdyType", "AddOnCmdyItem"]),
    _createVNode(_component_DeliveryListModal, {
      show: _ctx.showDeliveryListModal,
      "onUpdate:show": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showDeliveryListModal) = $event)),
      deliveryType: _ctx.selectDeliveryType,
      "onUpdate:deliveryType": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.selectDeliveryType) = $event)),
      buyerName: _ctx.buyerName,
      "onUpdate:buyerName": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.buyerName) = $event)),
      buyerEmail: _ctx.buyerEmail,
      "onUpdate:buyerEmail": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.buyerEmail) = $event)),
      buyerCity: _ctx.buyerCity,
      "onUpdate:buyerCity": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.buyerCity) = $event)),
      buyerDist: _ctx.buyerDist,
      "onUpdate:buyerDist": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.buyerDist) = $event)),
      buyerZip: _ctx.buyerZip,
      "onUpdate:buyerZip": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.buyerZip) = $event)),
      buyerAddr: _ctx.buyerAddr,
      "onUpdate:buyerAddr": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.buyerAddr) = $event)),
      onOk: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showDeliveryListModal = false))
    }, null, 8, ["show", "deliveryType", "buyerName", "buyerEmail", "buyerCity", "buyerDist", "buyerZip", "buyerAddr"]),
    _createVNode(_component_SelectCouponModal, {
      show: _ctx.showSelectCouponModal,
      "onUpdate:show": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.showSelectCouponModal) = $event)),
      selectCouponList: _ctx.selectCouponList,
      "onUpdate:selectCouponList": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.selectCouponList) = $event)),
      cmdyCouponList: _ctx.calcShoppingCartObject.CmdyCouponList,
      "onUpdate:cmdyCouponList": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.calcShoppingCartObject.CmdyCouponList) = $event)),
      isUpdate: _ctx.couponIsUpdate,
      "onUpdate:isUpdate": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.couponIsUpdate) = $event)),
      onOk: _cache[63] || (_cache[63] = ($event: any) => (_ctx.showSelectCouponModal = false))
    }, null, 8, ["show", "selectCouponList", "cmdyCouponList", "isUpdate"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}